import type { StylesRegistry } from '../../EdgeDocsCore/models/styles';

// Default firm styles (safe baseline). Replace with tenant-specific styles at startup if needed.
export const DEFAULT_FIRM_STYLES: StylesRegistry = {
  characterStyles: {
    BodyTextChar: {
      id: 'BodyTextChar',
      fontFamily: 'Times New Roman',
      fontSizePt: 12,
      fontWeight: 400,
      fontStyle: 'normal',
      colorHex: '#000000',
    },
    Heading1Char: {
      id: 'Heading1Char',
      fontFamily: 'Times New Roman',
      fontSizePt: 16,
      fontWeight: 600,
      fontStyle: 'normal',
      colorHex: '#000000',
    },
    FootnoteChar: {
      id: 'FootnoteChar',
      fontFamily: 'Times New Roman',
      fontSizePt: 10,
      fontWeight: 400,
      fontStyle: 'normal',
      colorHex: '#000000',
    },
    CitationField: {
      id: 'CitationField',
      fontFamily: 'Times New Roman',
      fontSizePt: 12,
      fontWeight: 600,
      fontStyle: 'normal',
      colorHex: '#0066CC',
    },
    SmallCapsChar: {
      id: 'SmallCapsChar',
      fontFamily: 'Times New Roman',
      fontSizePt: 12,
      fontWeight: 400,
      fontStyle: 'normal',
      openTypeFeatures: { smcp: true },
      colorHex: '#000000',
    },
  },
  paragraphStyles: {
    BodyText: {
      id: 'BodyText',
      alignment: 'left',
      lineSpacingMultiple: 1.2,
      baselineGrid: false,
      defaultCharacterStyleId: 'BodyTextChar',
    },
    Heading1: {
      id: 'Heading1',
      alignment: 'left',
      lineSpacingMultiple: 1.2,
      baselineGrid: false,
      defaultCharacterStyleId: 'Heading1Char',
    },
    FootnoteText: {
      id: 'FootnoteText',
      alignment: 'left',
      lineSpacingMultiple: 1.0,
      spaceBeforePt: 0,
      spaceAfterPt: 0,
      baselineGrid: false,
      defaultCharacterStyleId: 'FootnoteChar',
    },
    BlockQuote: {
      id: 'BlockQuote',
      alignment: 'left',
      indentLeftPt: 36,
      indentRightPt: 36,
      spaceBeforePt: 12,
      spaceAfterPt: 12,
      lineSpacingMultiple: 1.2,
      baselineGrid: false,
      defaultCharacterStyleId: 'BodyTextChar',
    },
    ListParagraph: {
      id: 'ListParagraph',
      alignment: 'left',
      indentLeftPt: 24,
      firstLineIndentPt: -12,
      spaceBeforePt: 0,
      spaceAfterPt: 6,
      lineSpacingMultiple: 1.2,
      baselineGrid: false,
      defaultCharacterStyleId: 'BodyTextChar',
    },
  },
};


